/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export default function store() {
    const reservationJson = window.sessionStorage.getItem('campingReservation');

    let reservationInitialState;
    let initialState = {};

    try {
        reservationInitialState = JSON.parse(reservationJson);
    } catch (ex) {
        reservationInitialState = null;
    }

    if (reservationInitialState) {
        initialState = { ...initialState, reservations: reservationInitialState };
    }

    return initialState;
}
